import { colors } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import NunitoTTF from '../fonts/Nunito-Regular.ttf';

const nunito = {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `url(${NunitoTTF}) format('truetype')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const theme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#4973b3',
        },
        secondary: {
            main: '#83c442',
            contrastText: '#fff'
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [nunito],
            },
        },
        MuiSelect: {
            selectMenu: {
                whiteSpace: "normal"
            }
        }
    },
    typography: {
        fontFamily: 'Nunito',
    }
});